import React from "react";
import { StyledContent } from "./styled";

const ContentContainer = ({ children }) => <StyledContent>{children}</StyledContent>;

export default ContentContainer;
